/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Wide_Lynx_VentInputs */

const fr_close_wide_lynx_vent = /** @type {(inputs: Close_Wide_Lynx_VentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur principale`)
};

/**

* @param {Close_Wide_Lynx_VentInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const close_wide_lynx_vent = /** @type {((inputs?: Close_Wide_Lynx_VentInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Wide_Lynx_VentInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_close_wide_lynx_vent(inputs)
});